import { useQuery } from "@tanstack/react-query"
import { AxiosError } from "axios"

import { useApi } from "../../../hooks/useApi"

export const MODELS_QUERY_KEY = ["view_models"]

export const usePublishedModels = () => {
  const { scientApi } = useApi()
  const { data, error, isLoading } = useQuery(MODELS_QUERY_KEY, scientApi.viewModels.list, {
    retry: 1,
  })
  return { directory: data, error: error as AxiosError, isLoading }
}
